<template>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-if="! is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-else-if="! featuredHighlight">
        <p>No highlights data found.</p>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0" v-else>
        <h1>Latest Cricket Videos</h1>
        <div class="artical-post">
            <div class="image-box">
                <span id="topHighlight" v-html="featuredHighlight.highlight"></span>
            </div>
            <h1>
                <router-link :to="{ name: 'matchDetail.Scorecard', params: { match: featuredHighlight.match.slug } }">
                    {{ featuredHighlight.title }}
            </router-link>
        </h1>
        <time class="time" :datetime="featuredHighlight.created_at | formatDate('YYYY-MM-DD')">
              {{ featuredHighlight.created_at | timeElaped }}
    </time>
    <div class="btn-wrap">
        <router-link :to="{ name: 'matchDetail.Scorecard', params: { match: featuredHighlight.match.slug } }" class="btn btn-dark">
            See Scorecard
    </router-link>
</div>
</div>
<section class="content-box" v-if="highlights.length >= 1">
    <strong class="h2 text-uppercase">Latest videos</strong>
    <div class="post-holder row">
        <div class="col-12 col-sm-6 post" v-for="(highlight,index) in highlights" :key="highlight.id">
            <a href="javascript:;">
                <div class="img-holder">
                    <span v-html="highlight.highlight"></span>
                </div>
                <div class="descrip">
                    <h2>
                        <router-link :to="{ name: 'matchDetail.Scorecard', params: { match: highlight.match.slug } }">
                            {{ highlight.title }}
                    </router-link>
                </h2>
                <time class="time" :datetime="highlight.created_at | formatDate('YYYY-MM-DD')">
                      {{ highlight.created_at | timeElaped }}
            </time>
        </div>
    </a>
    <!-------------------------------------------Ads---------------------------------------->
    <div style="display:flex;justify-content: center;width: 100%;margin-top: 20px;" class="d-md-none" v-if="index == 0">

        <div class="ft_async_tag" style="width: 300px;">
            
            <iframe :src="'https://servedby.flashtalking.com/imp/1/162408;7132164;201;jsiframe;PlanetCricket;PlanetCricket300x250/?ft_custom=&imageType=gif&ftDestID=35488582&ft_width=300&ft_height=250&click=&ftOBA=1&ftExpTrack=&gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&cachebuster='+Date.now()" allowFullScreen="true" webkitallowfullscreen="true" mozallowfullscreen="true" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" topmargin="0" leftmargin="0" allowtransparency="true" width="300" height="250">

                <a href="https://servedby.flashtalking.com/click/1/162408;7132164;0;209;0/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}&ft_width=300&ft_height=250&url=35488582" target="_blank">
                
                <img border="0" src="https://servedby.flashtalking.com/imp/1/162408;7132164;205;gif;PlanetCricket;PlanetCricket300x250/?gdpr=${GDPR}&gdpr_consent=${GDPR_CONSENT_78}&us_privacy=${US_PRIVACY}"></a>
                
                </iframe>
        </div>
        </div>
    <!-------------------------------------------Ads End---------------------------------------->
</div>
</div>
<div class="text-center">
    <a type="button" class="btn btn-dark" v-if="nextPageUrl" @click="loadMore()" href="javascript:;">Load more</a>
</div>
</section>
<!--      footer text-->
<div class="note-text text-center py-10">
    <p>
        Watch Thrilling and Exclusive Latest Cricket Videos of Your Favorite Teams and Tournaments. Keep Track of All the Latest Cricket Videos and Cricket Videos from the Past with Planet Cricket's Exclusive Videos.
    </p>
</div>
</div>
</template>

<script>
    export default {
        name: 'highlights',

        data() {
            return {
                featuredHighlight: null,
                highlights: [],
                nextPageUrl: ''
            }
        },
        metaInfo() {

            let title = "Watch Cricket Videos, Match Highlights Video, Interviews";
            let description = "Get your daily fix of cricket videos, watch your favorite match & players highlights, keep up to date with all the latest interviews of players - PlanetCricket";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        jsonld() {
            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return

            let events = [];
            this.highlights.forEach((video) => {
                events.push(
                        {
                            "@type": "VideoObject",
                            "name": video.title,
                            "description": video.title,
                            "thumbnailUrl": [
                                process.env.BASE_URL + 'public/images/logo1280x720.png'
                            ],
                            "uploadDate": video.created_at,
//                            "duration": "PT1M54S",
                            "contentUrl": process.env.BASE_URL,
                            "embedUrl": process.env.BASE_URL,
                        }
                )
            });
            return {
                "@context": "http://schema.org",
                "@type": "VideoObject",
                "name": this.featuredHighlight.title,
                "description": this.featuredHighlight.title,
                "thumbnailUrl": [
                    process.env.BASE_URL + 'public/images/logo1280x720.png'
                ],
                "uploadDate": this.featuredHighlight.created_at,
                "contentUrl": process.env.BASE_URL,
                "embedUrl": process.env.BASE_URL,
                "@context": "http://schema.org",
                "@graph": events
            };

        },

        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },
        methods: {
            main() {
                return this.$axios.get(this.$HIGHLIGHTS_API)
                        .then(response => {
                            this.is_data_ready = true
                            this.featuredHighlight = response.data.result.featuredHighlight
                            this.highlights = response.data.result.highlights || []
                            this.nextPageUrl = response.data.result.nextPageUrl
                            if (isBrowser) {
                                setTimeout(function () {
                                    $("#topHighlight iframe").height(360);
                                }, 100)
                            }
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },
            loadMore() {
                this.$axios.get(this.nextPageUrl)
                        .then(response => {
                            this.highlights = this.highlights.concat(response.data.result.highlights)
                            this.nextPageUrl = response.data.result.nextPageUrl
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        }
    }
</script>
